module.exports = __webpack_public_path__ + "media/images/gallery/constellations/delphinus/del_lines-549200d6a3e3465519ddcb10c29cecd8.gif";